import './toggle.scss'

import React from 'react'
import PropTypes from 'prop-types'

const Toggle = ({ checked, onClick, isToggling, children, dataAttr }) => (
  <div className='two-line super-toggle' data-attr={dataAttr}>
    <span className={`toggle-button${isToggling ? ' is-toggling' : ''}`} onClick={onClick}>
      <span className={`x-toggle-container${checked ? ' x-toggle-container-checked' : ''}`}>
        <label className='x-toggle-btn x-toggle-apprentus medium' />
      </span>
    </span>
    <div className='toggle-label'>{children}</div>
  </div>
)

Toggle.propTypes = {
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  isToggling: PropTypes.bool,
  children: PropTypes.node,
  dataAttr: PropTypes.string
}

export default Toggle
